import React from 'react';
import { bgImage } from './../scripts';
import { fonts, spacing, colors } from './../styles/theme.json';

const ProjectDetailCaption = (props) =>{
  let captionColor = '#ffffff';
  if (props.darkCaption) {
    captionColor = colors.black;
  };
  return (
    <div className={'caption-wrapper'} style={{color:captionColor}}>
      <div className={(props.PageGrid) ? 'project-caption ' + props.PageGrid : 'project-caption'}>
        <div>
          {(props.linksInCaption)
            ? <div className={'stop-propagation'} onClick={(e) => { e.stopPropagation();}}>
                <div className={'copy-left'}>
                  <h3 className={'project-name'}><span dangerouslySetInnerHTML={{ __html: props.ProjectName }} /></h3>
                  <h4 className={'image-description'}><span dangerouslySetInnerHTML={{ __html: props.ImageDescription }} /></h4>
                </div>
                {(props.ExpandIcon) && <div className={'expand'} style={bgImage('/static/icons/expand.svg')} />}
              </div>
            : <div className={'stop-propagation'}>
                <div className={'copy-left'}>
                  <h3 className={'project-name'}><span dangerouslySetInnerHTML={{ __html: props.ProjectName }} /></h3>
                  <h4 className={'image-description'}><span dangerouslySetInnerHTML={{ __html: props.ImageDescription }} /></h4>
                </div>
                {(props.ExpandIcon) && <div className={'expand'} style={bgImage('/static/icons/expand.svg')} />}
              </div>
          }
        </div>
      </div>
      <style jsx>{`
        .stop-propagation {
          width: 100%;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          position: relative;
          padding: 35% 2rem 2rem;
          z-index: 100;
        }
        .caption-wrapper {
          position: absolute;
          display: block;
          top: 0;
          left: 0;
          height: 100%;
          width: 100%;
          cursor: pointer;
          z-index: 2;
        }
        .caption-wrapper:hover > .project-caption {
          opacity: 1;
        }
        .project-caption {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          opacity: 0;
          will-change: opacity;
          transition: opacity 500ms ease;
        }
        .photo-grid {
          width: calc(100% - (${spacing.masonry_cell_padding} * 2));
          bottom: calc(${spacing.masonry_cell_padding});
          left: calc(${spacing.masonry_cell_padding});
        }
        .copy {
          position: relative;
          z-index: 10;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
        }
        .expand {
          height: 2rem;
          width: 2rem;
        }
        .bg-gradient {
          width: 100%;
          height: 100%;
          position: absolute;
          bottom: 0;
          left: 0;
          background: linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0) 70%,  rgba(76,76,76,1) 100%);
          mix-blend-mode: multiply;
          z-index: 0;
        }
        .project-name,
        .image-description {
          font-family: ${fonts.mallory};
          font-size: ${fonts.caption_size};
          letter-spacing: ${fonts.caption_spacing};
          text-transform: uppercase;
          line-height: 1.25;
        }
        .project-name {
          margin-bottom: .175rem;
          font-weight: bold;
        }
        .image-description {
          font-weight: 300;
        }
        .landing-grid > .copy > h3 {
          margin-bottom: .25rem;
          font-size: 1.75rem;
          text-transform: none;
        }
      `}</style>
    </div>
  );
};

export default ProjectDetailCaption;



// WEBPACK FOOTER //
// ./src/components/ProjectDetailCaption.js